<template><!-- svgo-optimised -->
<svg class="icon icon__ellipse" viewBox="0 0 7 8" xmlns="http://www.w3.org/2000/svg"><circle cx="3.6" cy="4" fill="currentColor" r="3.2"/></svg>
</template>